import { render, staticRenderFns } from "./GlossaryPhasesEdit.vue?vue&type=template&id=bafd02b0&"
import script from "./GlossaryPhasesEdit.vue?vue&type=script&lang=js&"
export * from "./GlossaryPhasesEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports